import React, { useEffect } from 'react';
import { useLeafletContext } from '@react-leaflet/core';

import _L from 'leaflet';
import 'leaflet.offline';
import { useRenderTracker } from '@app/shared/debug';

export const OfflineTileLayer = React.memo(function OfflineTileLayer() {
	useRenderTracker('OfflineTileLayer');
	const leaflet = useLeafletContext();
	const L = _L as any;

	useEffect(() => {
		const tileLayerOffline = L.tileLayer.offline(
			// 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			// 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
			// 'https://api.maptiler.com/maps/voyager/{z}/{x}/{y}{r}.png?key=iRgEs0wJarpRvpcaUPgp', // key revoked (403 Invalid key)
			// 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', // Wikimedia blocks non-Wikimedia sites (403)
			// 'https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', // CARTO now requires an API key too (403/watermark)
			// 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', // free, works, but busier styling
			// 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', // free, no key, CORS-enabled — HOT style, hosted by OpenStreetMap France
			// 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png', // 401 Unauthorized without a Stadia API key (required for non-localhost domains)

			'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
			{
				crossOrigin: 'crossorigin',
				updateWhenZooming: false, // Don't create intermediate tile containers during zoom animations
				updateWhenIdle: true,     // Load tiles only when map is idle (after animation ends)
			}
		);


		tileLayerOffline.addTo(leaflet.map);

		const controlSaveTiles = L.control.savetiles(tileLayerOffline, {
			// Expanded zoom range: 10 (city view) to 19 (detailed street view)
			// This prevents grey tiles when users zoom out/in
			zoomlevels: [11, 12, 13, 14, 15, 16, 17, 18]
		});

		return () => {
			leaflet.map.removeControl(controlSaveTiles);
			leaflet.map.removeLayer(tileLayerOffline); // Prevent duplicate tile layers on remount
		};
	}, []);

	return <div className="fragment"></div>;
});
